import type { Actions } from '../actions';
import {
  RCV_CREATE_RESELLERFOR,
  RCV_REMOVE_RESELLERFOR,
  REQ_CREATE_RESELLERFOR,
  REQ_REMOVE_RESELLERFOR,
  REQUEST_FAILED,
} from '../actions/reseller-for';
import { requestStatus, responseStatus } from '../shared/statuses';

interface ResellerForState {
  requestStatus: number;
  responseStatus: number;
}

const _initialState: ResellerForState = {
  requestStatus: requestStatus.WAITING,
  responseStatus: responseStatus.OK,
};

const resellerForReducer = (
  state: ResellerForState = _initialState,
  action: Actions,
): ResellerForState => {
  switch (action.type) {
    case REQ_CREATE_RESELLERFOR:
      return { requestStatus: requestStatus.CREATING, responseStatus: responseStatus.PENDING };
    case RCV_CREATE_RESELLERFOR:
      return { requestStatus: requestStatus.WAITING, responseStatus: responseStatus.OK };
    case REQ_REMOVE_RESELLERFOR:
      return { requestStatus: requestStatus.REMOVING, responseStatus: responseStatus.PENDING };
    case RCV_REMOVE_RESELLERFOR:
      return { requestStatus: requestStatus.WAITING, responseStatus: responseStatus.OK };
    case REQUEST_FAILED:
      return { requestStatus: requestStatus.WAITING, responseStatus: responseStatus.FAILED };
    default:
      return state;
  }
};

export default resellerForReducer;
